




































































































import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppTableDate from '@/components/AppTableDate.vue'
import ClaimDialog from '@/modules/Policy/components/ClaimDialog.vue'
import { Claim } from '../interfaces/claim'
import { deleteClaim, getClaimsOfPolicy } from '../gql/claim.gql'

@Component({
  components: {
    AppDialog,
    ClaimDialog,
    AppTableDate
  }
})
export default class PolicyDetailClaim extends mixins(ClaimDialog) {
  claims: Claim[] = [];

  tableColumn = [
    {
      field: 'id',
      title: 'ID',
      width: 60
    },
    {
      field: 'client',
      title: 'Client',
      slots: { default: 'client' }
    },
    {
      field: 'totalAmount',
      title: 'Total Amount'
    },
    {
      field: 'claimDate',
      title: 'Claim Date',
      slots: { default: 'claimDate' }
    },
    {
      field: 'note',
      title: 'Note',
      slots: { default: 'note' },
      width: 130
    },
    {
      field: 'createdAt',
      title: 'Create Date',
      slots: { default: 'createdAt' }
    },
    {
      field: 'updatedAt',
      title: 'Update Date',
      slots: { default: 'updatedAt' }
    },
    {
      field: 'createdBy.username',
      title: 'Creator'
    },
    {
      field: 'lastModifiedBy.username',
      title: 'Last ModifiedBy'
    },
    {
      field: 'actions',
      title: 'Actions',
      slots: { default: 'action_default' },
      fixed: 'right',
      width: 100
    }
  ];

  loading = false;

  claimDialog = {
    show: false,
    title: '',
    disable: false,
    isEdit: false
  };

  targetClaim: Claim | null = null;

  deleteDialog = {
    show: false
  };

  get claimInfo () {
    return this.targetClaim
  }

  mounted () {
    this.getClaims()
  }

  // 获取claim list
  async getClaims () {
    this.loading = true
    try {
      const result = await this.$apollo.query({
        query: getClaimsOfPolicy,
        variables: {
          policyId: +this.policy.id
        }
      })
      this.claims = result.data.getClaimsOfPolicy
      this.loading = false
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  handleEditClaim (row: Claim) {
    this.targetClaim = row
    this.claimDialog.isEdit = true
    this.claimDialog.title = 'Edit Claim'
    this.claimDialog.show = true
  }

  showClaimDialog (isEdit: boolean) {
    this.claimDialog.isEdit = isEdit
    this.claimDialog.show = true
    this.claimDialog.title = 'Create Claim '
  }

  successClaimDialog () {
    this.getClaims()
  }

  hideClaimDialog () {
    this.claimDialog.show = false
  }

  handleDeleteCliam (row: any) {
    this.deleteDialog.show = true
    this.targetClaim = row
  }

  // delete request
  async deleteConfirm () {
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteClaim,
        variables: {
          claimId: this.targetClaim && this.targetClaim.id
        }
      })
      if (result.data) {
        showNotification({
          msg: 'Delete Successfully',
          type: SnackType.Success
        })
        this.deleteDialog.show = false
        this.getClaims()
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  // 跳转详情页
  routeToDetail (item: any) {
    //
  }

  clickCell (data: any) {
    //
  }
}
